import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LuxonDateService } from '../../services/luxon-date.service';
import { DateTime } from 'luxon';

interface MaintenanceWindow {
  start: DateTime | null;
  end: DateTime | null;
}

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private maintenanceMode = new BehaviorSubject<boolean>(false);
  isMaintenance$ = this.maintenanceMode.asObservable();

  // Define your maintenance windows here
  private maintenanceWindows: MaintenanceWindow[] = [
    // Maintenance windows can be added here in the format shown in commented code
    // { start: this.luxonDate.parse("2024-01-20 20:00:00"), end: this.luxonDate.parse("2024-01-21 06:00:00") }
  ];

  constructor(private luxonDate: LuxonDateService) {
    this.checkMaintenanceWindow();
  }

  setMaintenanceMode(status: boolean): void {
    this.maintenanceMode.next(status);
  }

  private checkMaintenanceWindow(): void {
    const now = this.luxonDate.now(); // gets the current date and time

    // Check if 'now' is within any of the defined maintenance windows
    const maintenance = this.maintenanceWindows.some((window) => {
      // Ensure 'start' and 'end' are defined before comparing
      if (window.start && window.end) {
        // Luxon DateTime doesn't have isBetween() - implement manually
        return now >= window.start && now <= window.end;
      }
      return false; // If 'start' or 'end' is not defined, return false
    });

    // If a bypass flag is set in localStorage, don't enable maintenance mode
    if (localStorage.getItem('bypassMaintenance') === 'true') {
      this.setMaintenanceMode(false);
    } else {
      this.setMaintenanceMode(maintenance); // Update the maintenance mode status
    }
  }
}
